import {
  ColumnDataType,
  formatDate,
  formatNumber,
  LabelsType,
  TextEllipsis,
  Tooltip,
} from '@atlas-frontend/sdk';

export interface InputDataCellProps {
  code: string;
  dataType?: ColumnDataType | null;
  labels: LabelsType | null;
  value: string | number | null;
}

export function InputDataCell({
  labels,
  code,
  dataType,
  value,
}: InputDataCellProps) {
  if (labels && code in labels && value) {
    const valueName = labels[code][value]?.name;

    if (valueName) {
      return <Tooltip title={`${value} - ${valueName}`}>{value}</Tooltip>;
    }
  }

  let formattedValue = value;
  if (typeof value === 'number') {
    formattedValue = formatNumber(value);
  } else if (dataType === 'DATE') {
    formattedValue = formatDate(value) ?? '';
  }

  return <TextEllipsis>{formattedValue}</TextEllipsis>;
}
